/*
  bfroz-hero.js : port de la minuterie de _source/src/components/HeroSection.tsx.
  Toutes les 4500 ms (data-hero-interval), la photo suivante passe en opacity-100 et les autres
  en opacity-0 ; le fondu est fait par les classes transition-opacity duration-700 du markup.
  Idempotent : réinitialisé sur shopify:section:load (éditeur de thème).

  PHOTOS 2 à 5 : elles arrivent dans le HTML avec data-hero-src et SANS src (voir sections/hero-slideshow.liquid).
  Ce script leur pose le src :
    - après l'événement load + un moment d'inactivité, pour les 4 d'un coup (le préchargement volontaire de la
      source, new Image(), est conservé — il est seulement déplacé après le LCP) ;
    - et, filet de sécurité, au moment où une photo va entrer en scène et où la suivante approche, pour qu'aucun
      fondu ne puisse mener vers du vide si l'inactivité tarde.
  Avant ce changement, les 5 photos partaient ensemble au chargement (1,5 Mo) et l'image du LCP se battait
  pour la bande passante : LCP mobile mesuré à 12,6 s le 2026-09-04.
*/
(function () {
  'use strict';

  // Après l'événement load, puis un moment d'inactivité (au plus 2 s). Plafond de 3 s au total.
  function apresChargement(fn) {
    var fait = false;
    function unefois() {
      if (fait) return;
      fait = true;
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2000 });
      else window.setTimeout(fn, 300);
    }
    if (document.readyState === 'complete') return unefois();
    window.addEventListener('load', unefois);
    window.setTimeout(unefois, 3000);
  }

  function init(section) {
    if (section.__bfrozHero) section.__bfrozHero.stop();
    var slides = section.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;
    var interval = parseInt(section.getAttribute('data-hero-interval'), 10) || 4500;
    var active = 0;
    var timer = null;

    function hydrate(i) {
      var el = slides[i];
      if (!el) return;
      var srcset = el.getAttribute('data-hero-srcset');
      if (srcset) { el.setAttribute('srcset', srcset); el.removeAttribute('data-hero-srcset'); }
      var src = el.getAttribute('data-hero-src');
      if (!src) return;
      el.removeAttribute('data-hero-src');
      el.setAttribute('src', src);
    }
    function hydrateTout() {
      for (var i = 0; i < slides.length; i++) hydrate(i);
    }

    function paint() {
      for (var i = 0; i < slides.length; i++) {
        var on = i === active;
        slides[i].classList.toggle('opacity-100', on);
        slides[i].classList.toggle('opacity-0', !on);
      }
    }
    function next() {
      active = (active + 1) % slides.length;
      hydrate(active);                        // filet : celle qui entre en scène
      hydrate((active + 1) % slides.length);  // et la suivante, 4,5 s d'avance
      paint();
    }
    function start() {
      if (timer) return;
      timer = window.setInterval(next, interval);
    }
    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    paint();
    start();
    apresChargement(hydrateTout);
    section.__bfrozHero = { stop: stop, start: start };
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-hero-slideshow]');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('[data-hero-slideshow]') : null;
    if (s) init(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var s = e.target && e.target.querySelector ? e.target.querySelector('[data-hero-slideshow]') : null;
    if (s && s.__bfrozHero) s.__bfrozHero.stop();
  });
})();
